import { FaHtml5, FaCss3, FaNodeJs, FaReact, FaSass, FaFigma, FaPhoneAlt, FaUser, FaMapMarkerAlt, FaPaperPlane, FaInstagram, FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { DiJavascript } from "react-icons/di";
import { SiTypescript } from "react-icons/si";
import { SiMaterialui, SiSolidity, SiTailwindcss, SiNextdotjs } from "react-icons/si";
// import work1 from "./assets/work1.png"; 
// import work2 from "./assets/work2.png";
// import work3 from "./assets/work3.png";
// import work4 from "./assets/work4.png";
// import work5 from "./assets/work5.png";
// import work6 from "./assets/work6.png";
import bluemoon from './assets/bluemoon.png'
import seekcoin from './assets/seekcoin.png'
import opencanvas from './assets/opencanvas.png'
import winBusd from './assets/winBusd.png'
import rc from './assets/rc.png'
import tpunks from './assets/tpunks.png'
import zonoswap from './assets/zonoswap.png'
import shitcoin from './assets/shitcoin.png'
import sphynx from './assets/sphynx.png'
// import solardex from './assets/solardex.png'



export const navLinks = ["home", "about", "skills", "portfolio", "contact"]

export const socialIcons = [
  // <FaDribbble />,
  {
    id: 1,
    icon: <FaLinkedin />,
    link: 'https://www.linkedin.com/in/muhammad-sufyan-blockchain-developer/'

  },
  {
    id: 2,
    icon: <FaGithub />,
    link: 'https://github.com/msufyan634'

  },
  {
    id: 3,
    icon: <FaTwitter />,
    link: 'https://twitter.com/Suf_yan_07'

  },
  {
    id: 4,
    icon: <FaInstagram />,
    link: 'https://www.instagram.com/suf_yan209'

  }
]

export const bios = [
  {
    id: 1,
    icon: <FaUser />,
    key: "Name",
    value: "Sufyan"
  },
  {
    id: 2,
    icon: <FaPhoneAlt />,
    key: "Phone",
    value: "+923167080634"
  },
  {
    id: 3,
    icon: <FaPaperPlane />,
    key: "Email",
    value: "msufyan833@gmail.com"
  }
]

export const icons = [<FaHtml5 />, <FaCss3 />, <DiJavascript />, <SiTypescript />, <FaReact />,
<FaNodeJs />, <FaSass />, <FaFigma />, <SiMaterialui />, <SiSolidity />, <SiTailwindcss />, <SiNextdotjs />]

export const experiences = [
  {
    id: 1,
    year: "2021-2022",
    position: "Blockchain and MERN Stack",
    company: "https://quecko.com/"
  },
  {
    di: 2,
    year: "2020",
    position: "Junior Web Developer",
    company: "https://www.bloctechsolutions.com/"
  },
  {
    id: 3,
    year: "2019",
    position: "Intern Web Dveloper",
    company: "https://www.bloctechsolutions.com/"
  }
]
export const finishes = [
  {
    id: 1,
    number: '3+',
    itemName: "Years Of Experience"
  },
  {
    id: 2,
    number: "15+",
    itemName: "Satisfied Customers"
  },
  {
    id: 3,
    number: "20+",
    itemName: "Designed Items"
  },
  {
    id: 4,
    number: "5+",
    itemName: "Clients Served"
  }
]
export const workImages = [
  {
    id: 1,
    img: zonoswap,
    name: "zonoswap",
    category: "Swap",
    link: 'https://farms.zonoswap.com/'
  },
  {
    id: 2,
    img: seekcoin,
    name: "seekcoin",
    category: "All",
    link: 'https://seekcoin-presale.netlify.app/'
  },
  {
    id: 3,
    img: rc,
    name: "rcLaunchpad",
    category: "LaunchPad",
    link: 'https://rcsale.app/'
  },
  {
    id: 4,
    img: bluemoon,
    name: "seekcoin",
    category: 'NFT',
    link: 'https://bluemoon.io/'
  },
  {
    id: 5,
    img: winBusd,
    name: "winBusd",
    category: "All",
    link: 'https://www.winbusd.io/#/dashboard'
  },
  {
    id: 6,
    img: shitcoin,
    name: "shitcoin",
    category: "NFT",
    link: 'https://shitcoin69.com/'
  },

  {
    id: 7,
    img: opencanvas,
    name: "opencanvas",
    category: "Staking",
    link: 'https://opencanvas.app/'
  },
  {
    id: 8,
    img: tpunks,
    name: "tpunks",
    category: "NFT",
    link: 'https://tpunks.com/'
  },


  {
    id: 9,
    img: sphynx,
    name: "shitcoin",
    category: "NFT",
    link: 'https://thesphynx.co/'
  },
  // {
  //   id: 10,
  //   img: solardex,
  //   name: "shitcoin",
  //   category: "design",
  //   link:'https://bluemoon.io/'
  // }
]


export const workNavs = [
  "All", "NFT", "Staking",  "LaunchPad", 'Swap'
]

export const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    infoText: "Punjab Faisalabad"
  },
  {
    id: 2,
    icon: <FaPaperPlane />,
    infoText: "msufyan833@gmail.com"
  },
  {
    id: 3,
    icon: <FaPhoneAlt />,
    infoText: "+923167080634"
  }
]
